import { useState } from 'react';

/**
 * @typedef Options
 * @property {boolean} [parse=true]
 *
 * @param {string} keyName
 * @param {string} defaultValue
 * @param {Options} options
 */
const useLocalStorage = (keyName, defaultValue, options) => {
  const opt = {
    parse: true,
  };
  if (options?.parse === undefined) {
    opt.parse = options?.parse;
  }
  const [storageValue, setStorageValue] = useState(() => {
    const value = window.localStorage.getItem(keyName);

    if (value) {
      if (opt.parse === false) {
        return value;
      } else {
        return JSON.parse(value);
      }
    } else if (defaultValue) {
      window.localStorage.setItem(keyName, opt.parse ? JSON.stringify(defaultValue) : defaultValue);
      return defaultValue;
    }
  });

  const setValue = (newValue, setValueOptionsParams) => {
    let setValueOptions = {};
    setValueOptions.string = setValueOptionsParams?.string !== undefined ? setValueOptionsParams.string : false;
    if (setValueOptions === false) {
      window.localStorage.setItem(keyName, newValue);
      setStorageValue(newValue);
    } else {
      window.localStorage.setItem(keyName, JSON.stringify(newValue));
      setStorageValue(newValue);
    }
  };

  return [storageValue, setValue];
};

export default useLocalStorage;
